import { baseRoutes } from '../../core/config/routes';

export const routes = {
  ...baseRoutes,
  admin: {
    ...baseRoutes.admin,
    employees: {
      list: '/admin/employees',
      new: '/admin/employees/new',
      edit: '/admin/employees/:id',
      version: '/admin/employees/:id/version',
    },
    documents: {
      list: '/admin/documents',
      listForEmployee: '/admin/employee-documents',
      folder: '/admin/documents/:id',
      folderForEmployee: '/admin/employee-documents/:id',
      new: '/admin/documents/new',
      newForEmployee: '/admin/documents/new-for-employee',
    },
    documentTemplates: {
      list: '/admin/documents?activeTab=1',
      new: '/admin/documents/templates/new',
      edit: '/admin/documents/templates/:id',
    },
    jobTitles: {
      list: '/admin/job-titles',
      new: '/admin/job-titles/new',
      edit: '/admin/job-titles/:id',
    },
    departments: {
      list: '/admin/departments',
      new: '/admin/departments/new',
      edit: '/admin/departments/:id',
    },
    tasks: {
      list: '/admin/tasks',
      view: '/admin/tasks/:id',
    },
    employeeTimeOffs: {
      availability: '/admin/time-offs/availability',
      availabilityForEmployee: '/admin/time-offs/employee-availability',
    },
    globalDocumentTemplates: {
      list: '/admin/global-document-templates',
      new: '/admin/global-document-templates/new',
      edit: '/admin/global-document-templates/:id',
    },
  },
  auth: {
    ...baseRoutes.auth,
  },
};
